<template>
  <ButtonGrid :buttons="supportMaterials">
    <button slot="button" slot-scope="{ button }" :class="`ui basic fluid icon button`" @click="download(button)">
      <i :class="`ui file outline icon`"></i>
      {{ button }}
    </button>
  </ButtonGrid>
</template>

<script>
import ButtonGrid from '@/components/shared/ButtonGrid';
import ContentService from '@/services/api/content/content-service';

export default {
  name: 'SupportMaterials',
  props: ['syncguid'],
  components: {
    ButtonGrid,
  },
  computed: {
    supportMaterials() {
      return this.$store.getters.contentById(this.syncguid).materials || [];
    },
  },
  methods: {
    download(fileName) {
      ContentService.downloadSupportMaterial(this.syncguid, fileName);
    },
  },
};
</script>
